import {Component, OnInit} from '@angular/core';
import {ApiService, MyIp} from '../../service/api.service';
import {IpType} from '../../model/iptype.model';
import {Command} from '../../model/command.model';
import {Actions} from '../../model/actions.model';
import {Destinations} from '../../model/destinations.model';
import {FormBuilder, FormGroup} from '@angular/forms';
import {InputForm} from '../../model/input-form.model';
import {Subscription} from 'rxjs';


@Component({
  selector: 'app-body',
  templateUrl: './body.component.html',
  styleUrls: ['./body.component.css']
})

export class BodyComponent implements OnInit {
  // Model mappings
  actions = Actions;
  destinations = Destinations;
  ipType = IpType;

  // GUI controls
  showResults = false;
  results: any;
  showSpinner = false;
  isError = false;

  myIpAddress: MyIp = new MyIp();
  destinationType: Destinations = Destinations.your_ip;
  targetIp: string;
  errorMsg: string;

  inputForm: FormGroup;
  devices: any = [];

  constructor(
    public apiService: ApiService,
    private formBuilder: FormBuilder
  ) {
  }

  ngOnInit(): void {
    this.getMyIp();
    this.getDevices();
    this.inputForm = this.createFormGroup();
  }

  getMyIp(): Subscription {
    return this.apiService.getMyIp().subscribe((data: MyIp) => {
      this.myIpAddress = data;
      this.targetIp = this.myIpAddress.my_ip;
    });
  }

  createFormGroup(): FormGroup {
    return this.formBuilder.group(new InputForm());
  }

  submitRequest(): void {
    const command = this.buildCommand();
    console.log(command);
    this.showResults = false;
    this.isError = false;
    this.showSpinner = true;
    this.apiService.postCommand(command).subscribe(
      (data) => {
        this.showSpinner = false;
        this.results = data;
        console.log(data);
        this.showResults = true;
      }, error => {
        this.showSpinner = false;
        this.isError = true;
        this.errorMsg = 'An error occurred, please try again.';
      }, () => {
        this.showSpinner = false;
      });
  }

  setTarget(): void {
    switch (this.inputForm.value.destination) {
      case Destinations.ip_address:
        break;
      case Destinations.gcx_sites:
        this.inputForm.patchValue({target: this.inputForm.value.destinationDevice});
        break;
      default:
        this.inputForm.patchValue({target: this.myIpAddress.my_ip});
        break;
    }
  }

  buildCommand(): Command {
    this.setTarget();
    const command = new Command(this.inputForm.value.sourceDevice,
      this.inputForm.value.ipType, this.inputForm.value.target, this.destinationType);
    switch (this.inputForm.value.action) {
      case this.actions.b_trace:
        command.command = this.actions.b_trace;
        break;
      case this.actions.c_route:
        command.command = this.actions.c_route;
        break;
      default:
        command.command = this.actions.a_ping;
        break;
    }
    return command;
  }

  getDevices(): Subscription {
    return this.apiService.getDevices().subscribe((data: {}) => {
      this.devices = data;
    });
  }
}
